import z from 'zod';

const wordSplitRegex = /([^A-Z])([A-Z]+)/g;
const mergeConnectorsRegex = /[_-\s]+/g;
const trimRegex = /^-+|-+$/g;

export const kebabString = z
  .string()
  .transform(input => {
    if (typeof input !== 'string') return input;
    return input
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // remove diacritics
      .replace(wordSplitRegex, '$1-$2')
      .replace(mergeConnectorsRegex, '-')
      .replace(trimRegex, '')
      .toLowerCase();
  })
  .refine(val => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(val), { message: 'Value must be lower-kebab-case' });

export const primitive = z.union([z.string(), z.number(), z.boolean(), z.date()]);

export const customEventBaseFields = {
  module: kebabString.optional(),
  itemId: kebabString.optional(),
  elementId: kebabString.optional(),
  frameCorrelationId: kebabString.optional(),
};
